import { RouteEnum } from "../../../common/enums/RouteEnum";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import schoolImage from "../../../common/images/school.svg";
import editImage from "../../../common/images/edit.svg";
import accountCircleOffImage from "../../../common/images/account-circle-off.svg";
import { NavigateFunction } from "react-router";
import { PrimaryTableRow } from "@hatch-digital-nl/abs-storybook/legacy";
import { Dispatch } from "redux";
import {
    setIsEditEmployeeModalOpen,
    setSelectedEmployee,
} from "../../../modals/EditEmployeeModal/EditEmployeeModalSlice";
import {
    setIsDeactivateEmployeeConfirmationModalOpen,
    setDeactivatedEmployee,
} from "../../../modals/DeactivateEmployeeConfirmationModal/DeactivateEmployeeConfirmationModalSlice";
import { StatusEnum } from "../../../common/enums/StatusEnum";

interface Args {
    employeesData: EmployeeInterface[];
    navigate: NavigateFunction;
    dispatch: Dispatch;
    employeeId: number;
}

export const mapEmployeeDataToRow = (args: Args): PrimaryTableRow[][] => {
    const { employeesData, navigate, dispatch, employeeId } = args;

    return employeesData?.map((employee: EmployeeInterface) => {
        const actionData = [
            {
                iconUrl: schoolImage,
                onClick: () =>
                    navigate(RouteEnum.EMPLOYEES + "/" + employee.id),
                title: "Bekijken",
            },
            {
                iconUrl: editImage,
                onClick: () => {
                    dispatch(setIsEditEmployeeModalOpen(true));
                    dispatch(setSelectedEmployee(employee));
                },
                title: "Bewerken",
            },
        ];

        if (
            employeeId !== employee.id &&
            (employee.status.code === StatusEnum.ACTIVE ||
                employee.status.code === StatusEnum.INVITED)
        ) {
            actionData.push({
                iconUrl: accountCircleOffImage,
                onClick: () => {
                    dispatch(
                        setIsDeactivateEmployeeConfirmationModalOpen(true),
                    );
                    dispatch(setDeactivatedEmployee(employee));
                },
                title: "Uit dienst nemen",
            });
        }

        const fullName = `${employee.user.first_name}${
            employee.user.insertion ? ` ${employee.user.insertion}` : ""
        } ${employee.user.last_name}`;

        return [
            { value: fullName },
            { value: employee.employee_id?.toString() || "-" },
            {
                value: employee.function_groups?.length
                    ? employee.function_groups.map((fg) => fg.name)
                    : "-",
            },
            {
                value: employee.roles?.length
                    ? [...new Set(employee.roles.map((role) => role.label))]
                    : "-",
            },
            {
                value: employee.status?.name || "-",
            },
            {
                value:
                    employee.certificate_totals?.active_count?.toString() ||
                    "0",
            },
            {
                value:
                    employee.certificate_totals?.missing_qualifications_count?.toString() ||
                    "0",
            },
            {
                value:
                    employee.certificate_totals?.expiring_soon_count?.toString() ||
                    "0",
            },
            {
                value: "",
                actionData,
            },
        ];
    });
};
